<div class="card mb-3">
    <div class="card-header d-flex flex-row justify-content-between">
        <h2 class="card-title mb-0">Top Up Point Log</h2>
    </div>
    <div class="p-3">
        <div class="d-flex flex-row gap-3 align-items-end mb-3 flex-wrap">
            <div>
                <label for="name" class="form-label">Date From</label>
                <input type="date" class="form-control form-contrl-lg" [(ngModel)]="data.date_from" />
            </div>
            <div>
                <label for="name" class="form-label">Date To</label>
                <input type="date" class="form-control form-contrl-lg" [(ngModel)]="data.date_to" />
            </div>
            <div>
                <label for="name" class="form-label">Player Search</label>
                <input type="text" class="form-control form-contrl-lg" [(ngModel)]="data.player_search"
                    placeholder="Code, Name, or Mobile" />
            </div>
            <button class="btn btn-primary" (click)="filter()">Filter</button>
        </div>
    </div>
</div>

<div class="mb-3 card" *ngIf="!load && items.length > 0">
    <div class="card-header">
        <h3 class="mb-0 text-light fw-bolder">Summary</h3>
    </div>
    <div class="card-body p-3 d-flex flex-row flex-wrap gap-3 align-items-center">
        <div class="card">
            <div class="card-body">
                <p class="mb-0"><b>Total Records:</b> {{summary.total_count}}</p>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <p class="mb-0"><b>Total Bonus:</b> {{summary.total_bonus | number:'1.2-2'}}</p>
            </div>
        </div>
        <nav>
            <ul class="pagination mb-0">
                <li class="page-item"><a class="page-link" (click)="filter(page_nat.current_page - 1)"
                        *ngIf="page_nat.current_page > 1">
                        <</a>
                </li>
                <li class="page-item" *ngFor="let page of [].constructor(page_nat.total_pages); let i = index"
                    [class.active]="page_nat.current_page == i + 1">
                    <a class="page-link" (click)="filter(i + 1)">{{i + 1}}</a>
                </li>
                <li class="page-item"><a class="page-link" (click)="filter(page_nat.current_page + 1)"
                        *ngIf="page_nat.current_page < page_nat.total_pages">></a></li>
                <li>
                    <input type="number" class="form-control form-control-sm h-100" style="width: 60px;"
                        [(ngModel)]="page_nat.current_page" (change)="filter(page_nat.current_page)" />
                </li>
                <li class="d-flex flex-row align-items-center px-2">Page {{page_nat.current_page}} of
                    {{page_nat.total_pages}}</li>
            </ul>
        </nav>
    </div>
</div>

<div class="card">
    <div class="card-body p-0">

        <ng-container *ngIf="!load && items.length == 0">
            <h3 class="mb-0 px-2 py-3">No Data Available</h3>
        </ng-container>

        <ng-container *ngIf="load">
            <div class="d-flex flex-row align-items-center justify-content-center p-2">
                <div class="loader"></div>
            </div>
        </ng-container>

        <ng-container *ngIf="!load && items.length > 0">
            <table class="table table-sm table-striped mb-0" style="font-size: 12px;">
                <thead>
                    <tr>
                        <th>No</th>
                        <th>Transaction ID</th>
                        <th>Date/Time</th>
                        <th>Player Code</th>
                        <th>Player Name</th>
                        <th>Player Mobile</th>
                        <th>Admin User</th>
                        <th class="text-end">Bonus Amount</th>
                        <th class="text-end">Balance After</th>
                        <th>Remark</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of items; let i = index;">
                        <td>{{(page_nat.current_page - 1) * page_nat.page_limit + (i + 1)}}</td>
                        <td>{{item.transaction_id}}</td>
                        <td>{{item.timestamp | date: "dd-MM-yyyy HH:mm:ss"}}</td>
                        <td>{{item.player_code}}</td>
                        <td>{{item.player_name}}</td>
                        <td>{{item.player_mobile}}</td>
                        <td>{{item.admin_name}}</td>
                        <td class="text-end">{{item.bonus | number:'1.2-2'}}</td>
                        <td class="text-end">{{item.balance | number:'1.2-2'}}</td>
                        <td>{{item.remark}}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="7" class="text-end"><b>Total</b></td>
                        <td class="text-end"><b>{{summary.total_bonus | number:'1.2-2'}}</b></td>
                        <td colspan="2"></td>
                    </tr>
                </tfoot>
            </table>
        </ng-container>
    </div>
</div>